import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { useState } from 'react'
import Navbar from '@/components/Navbar'
import Footer from '@/components/Footer'
import HomePage from '@/components/HomePage'
import FleetPage from '@/components/FleetPage'
import BookingPage from '@/components/BookingPage'
import MyReservationsPage from '@/components/MyReservationsPage'
import AdminDashboard from '@/components/AdminDashboard'
import AgendaPage from '@/components/AgendaPage'
import VehicleForm from '@/components/VehicleForm'
import ReservationForm from '@/components/ReservationForm'
import AuthModal from '@/components/AuthModal'
import VehiclePhotosPage from '@/components/VehiclePhotosPage'

function App() {
  const [showAuthModal, setShowAuthModal] = useState(false)

  return (
    <Router>
      <div className="min-h-screen bg-white flex flex-col">
        <Navbar onAuthClick={() => setShowAuthModal(true)} />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/flotte" element={<FleetPage />} />
            <Route path="/reserver" element={<BookingPage />} />
            <Route path="/mes-reservations" element={<MyReservationsPage />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/vehicule/nouveau" element={<VehicleForm />} />
            <Route path="/admin/vehicule/:id" element={<VehicleForm />} />
            <Route path="/admin/reservation/nouvelle" element={<ReservationForm />} />
            <Route path="/admin/reservation/:id" element={<ReservationForm />} />
            <Route path="/agenda" element={<AgendaPage />} />
            <Route path="/vehicule/:id/photos" element={<VehiclePhotosPage />} />
          </Routes>
        </main>
        <Footer />
        <AuthModal isOpen={showAuthModal} onClose={() => setShowAuthModal(false)} />
      </div>
    </Router>
  )
}

export default App
